import { useState, useEffect } from "react";
import { Box, Button, Typography, FmdGoodOutlinedIcon, FmdBadOutlinedIcon, ExplorerPlusIcon
 } from 'src/components';
import { useAuth, isOnline } from 'src/utils';
import { useIsMobile } from 'src/hooks';
import UserVisibilityModal from './user-visibility-modal';
import MembershipsModal from 'src/pages/memberships/memberships-modal';

export default function UserVisibilityButton({ isDrawerOpen, locationPermissionDenied, updateLocationAndFetchUsers }) {
    const [displayPrivacyModal, setDisplayPrivacyModal] = useState(false);
    const [displayMembershipsModal, setDisplayMembershipsModal] = useState(false);
    const [userOffline, setUserOffline] = useState(!isOnline()); 

    const isMobile = useIsMobile();
    const { user } = useAuth();

    const freeMembership = !user || user?.membership === "Free";
    const isMembershipsEnabled = import.meta.env.VITE_FEATURE_MEMBERSHIPS === 'true';
    const pinnedError = user?.privacy === "Pinned" && !user?.pinnedLocation?.coordinates;
    locationPermissionDenied = locationPermissionDenied && !userOffline;

    useEffect(() => {
    const interval = setInterval(() => {
      const currentlyOffline = !isOnline();
      if (currentlyOffline !== userOffline) {
        setUserOffline(currentlyOffline);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [userOffline]);

    return (<>
        {user && (<>
            <Box sx={{
                width: isMobile ? '90%' : '50%',
                position: 'absolute',
                top: isMobile ? 'calc(70px + var(--safe-area-top, 0px))' : (isDrawerOpen ? 40 : 33),
                left: isMobile ? 15 : (isDrawerOpen ? 460 : 330),
                transition: 'all 0.4s ease-in-out'}}>

                {freeMembership && isMembershipsEnabled && (
                    <Box sx={{float: 'left', cursor: 'pointer'}} onClick={() => setDisplayMembershipsModal(true)}>
                        <ExplorerPlusIcon />
                    </Box>
                )}

                <Box sx={{ display: "flex", gap: 1, float: isMobile ? 'right' : 'left', mt: isMobile ? 0 : 1, }}>
                    
                    {userOffline && (
                        <Button
                            size="small"
                            sx={{
                                bgcolor: "warning.main",
                                color: "#fff",
                                borderRadius: 100,
                                "&:hover": { bgcolor: "warning.dark" },
                                pr: 1.5,
                                ml: isMobile ? 0 : 1,
                            }}>
                            <FmdBadOutlinedIcon fontSize="small" />
                            <Typography variant="body2" fontWeight={600} sx={{ ml: 0.5 }}>
                                Offline
                            </Typography>
                        </Button>
                    )}

                    {/* Location Permission Indicator */}
                    {locationPermissionDenied && (
                        <Button
                            onClick={updateLocationAndFetchUsers}
                            size="small"
                            sx={{
                                bgcolor: locationPermissionDenied ? "warning.main" : "success.main",
                                color: "#fff",
                                borderRadius: 100,
                                "&:hover": {
                                    bgcolor: locationPermissionDenied ? "warning.dark" : "success.dark",
                                }, 
                                zIndex: 0, 
                                pr: 1.5,
                                ml: isMobile ? 0 : 1,
                            }}>
                            <FmdBadOutlinedIcon fontSize="small" />
                            <Typography variant="body2" fontWeight={600} sx={{ ml: 0.5 }}>
                                Retry Location
                            </Typography>
                        </Button>
                    )}

                    {/* Privacy Button */}
                    <Button
                        onClick={() => setDisplayPrivacyModal(true)}
                        size="small"
                        sx={{
                            bgcolor: pinnedError ? "warning.main" : "background.paper",
                            color: pinnedError ? "#fff" : "text.primary",
                            borderRadius: 100,
                            "&:hover": { 
                                bgcolor: pinnedError ? "warning.dark" : "background.default" 
                            }, 
                            zIndex: 0, 
                            pr: 1.5
                        }}>
                        <FmdGoodOutlinedIcon fontSize="small" />
                        <Typography variant="body2" fontWeight={600} sx={{ ml: 0.5 }}>
                            {pinnedError ? "Pin a location" : user.privacy}
                        </Typography>
                    </Button>
                </Box>

            </Box>

            <UserVisibilityModal 
                display={displayPrivacyModal} 
                setDisplay={setDisplayPrivacyModal}
                locationPermissionDenied={locationPermissionDenied}/>

            {displayMembershipsModal && (
                <MembershipsModal
                    open={displayMembershipsModal}
                    onClose={() => setDisplayMembershipsModal(false)}
                />
            )}

        </>)}
        </>
    );
}
